/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-63ed8f4f.js';
import '@carbon/icon-helpers';
import React from 'react';
var didWarnAboutDeprecation = {};

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
});

var StarHalf20 = /*#__PURE__*/React.forwardRef(function StarHalf20(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, children);
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z"
});

var StarHalf16 = /*#__PURE__*/React.forwardRef(function StarHalf16(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref4, children);
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
});

var StarReview32 = /*#__PURE__*/React.forwardRef(function StarReview32(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref6, _ref7, children);
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
});

var StarReview24 = /*#__PURE__*/React.forwardRef(function StarReview24(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref9, _ref10, children);
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
});

var StarReview20 = /*#__PURE__*/React.forwardRef(function StarReview20(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref12, _ref13, children);
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
});

var StarReview16 = /*#__PURE__*/React.forwardRef(function StarReview16(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref15, _ref16, children);
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM20,26H12V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H22V24a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H6V12.0615l10-7.79,10,7.8Z"
});

var StayInside32 = /*#__PURE__*/React.forwardRef(function StayInside32(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref18, _ref19, children);
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM20,26H12V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H22V24a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H6V12.0615l10-7.79,10,7.8Z"
});

var StayInside24 = /*#__PURE__*/React.forwardRef(function StayInside24(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref21, _ref22, children);
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM20,26H12V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H22V24a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H6V12.0615l10-7.79,10,7.8Z"
});

var StayInside20 = /*#__PURE__*/React.forwardRef(function StayInside20(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref24, _ref25, children);
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM20,26H12V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H22V24a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H6V12.0615l10-7.79,10,7.8Z"
});

var StayInside16 = /*#__PURE__*/React.forwardRef(function StayInside16(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref27, _ref28, children);
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
});

var StemLeafPlot32 = /*#__PURE__*/React.forwardRef(function StemLeafPlot32(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref30, children);
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
});

var StemLeafPlot24 = /*#__PURE__*/React.forwardRef(function StemLeafPlot24(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref32, children);
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
});

var StemLeafPlot20 = /*#__PURE__*/React.forwardRef(function StemLeafPlot20(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref34, children);
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
});

var StemLeafPlot16 = /*#__PURE__*/React.forwardRef(function StemLeafPlot16(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref36, children);
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
});

var Stethoscope32 = /*#__PURE__*/React.forwardRef(function Stethoscope32(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref38, children);
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
});

var Stethoscope24 = /*#__PURE__*/React.forwardRef(function Stethoscope24(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref40, children);
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
});

var Stethoscope20 = /*#__PURE__*/React.forwardRef(function Stethoscope20(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref42, children);
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
});

var Stethoscope16 = /*#__PURE__*/React.forwardRef(function Stethoscope16(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref44, children);
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var Stop32 = /*#__PURE__*/React.forwardRef(function Stop32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref46, children);
});

var _ref48 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var Stop24 = /*#__PURE__*/React.forwardRef(function Stop24(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref48, children);
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var Stop20 = /*#__PURE__*/React.forwardRef(function Stop20(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref50, children);
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
});

var Stop16 = /*#__PURE__*/React.forwardRef(function Stop16(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref52, children);
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
});

var StopFilled32 = /*#__PURE__*/React.forwardRef(function StopFilled32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref54, children);
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
});

var StopFilled24 = /*#__PURE__*/React.forwardRef(function StopFilled24(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref56, children);
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
});

var StopFilled20 = /*#__PURE__*/React.forwardRef(function StopFilled20(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref58, children);
});

var _ref60 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z"
});

var StopFilled16 = /*#__PURE__*/React.forwardRef(function StopFilled16(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref60, children);
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var StopFilledAlt32 = /*#__PURE__*/React.forwardRef(function StopFilledAlt32(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref62, children);
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var StopFilledAlt24 = /*#__PURE__*/React.forwardRef(function StopFilledAlt24(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref64, children);
});

var _ref66 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var StopFilledAlt20 = /*#__PURE__*/React.forwardRef(function StopFilledAlt20(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref66, children);
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
});

var StopFilledAlt16 = /*#__PURE__*/React.forwardRef(function StopFilledAlt16(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref68, children);
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref71 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
});

var StopOutline32 = /*#__PURE__*/React.forwardRef(function StopOutline32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref70, _ref71, children);
});

var _ref73 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
});

var StopOutline24 = /*#__PURE__*/React.forwardRef(function StopOutline24(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref73, _ref74, children);
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref77 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
});

var StopOutline20 = /*#__PURE__*/React.forwardRef(function StopOutline20(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref76, _ref77, children);
});

var _ref79 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z"
});

var StopOutline16 = /*#__PURE__*/React.forwardRef(function StopOutline16(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref79, _ref80, children);
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
});

var _ref83 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 12H20V20H12z"
});

var StopOutlineFilled32 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled32(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref82, _ref83, children);
});

var _ref85 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 12H20V20H12z"
});

var StopOutlineFilled24 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled24(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref85, _ref86, children);
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
});

var _ref89 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 12H20V20H12z"
});

var StopOutlineFilled20 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled20(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref88, _ref89, children);
});

var _ref91 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z"
});

var _ref92 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H10V10H6z"
});

var StopOutlineFilled16 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled16(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref91, _ref92, children);
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
});

var _ref95 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "12",
  r: "1"
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "20",
  r: "1"
});

var StorageRequest32 = /*#__PURE__*/React.forwardRef(function StorageRequest32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref94, _ref95, _ref96, children);
});

var _ref98 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
});

var _ref99 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "12",
  r: "1"
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "20",
  r: "1"
});

var StorageRequest24 = /*#__PURE__*/React.forwardRef(function StorageRequest24(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref98, _ref99, _ref100, children);
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
});

var _ref103 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "12",
  r: "1"
});

var _ref104 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "20",
  r: "1"
});

var StorageRequest20 = /*#__PURE__*/React.forwardRef(function StorageRequest20(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref102, _ref103, _ref104, children);
});

var _ref106 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
});

var _ref107 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "12",
  r: "1"
});

var _ref108 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "7",
  cy: "20",
  r: "1"
});

var StorageRequest16 = /*#__PURE__*/React.forwardRef(function StorageRequest16(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref106, _ref107, _ref108, children);
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
});

var Store32 = /*#__PURE__*/React.forwardRef(function Store32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref110, children);
});

var _ref112 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
});

var Store24 = /*#__PURE__*/React.forwardRef(function Store24(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref112, children);
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
});

var Store20 = /*#__PURE__*/React.forwardRef(function Store20(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref114, children);
});

var _ref116 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
});

var Store16 = /*#__PURE__*/React.forwardRef(function Store16(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref116, children);
});

var _ref118 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
});

var StormTracker32 = /*#__PURE__*/React.forwardRef(function StormTracker32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref118, children);
});

var _ref120 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
});

var StormTracker24 = /*#__PURE__*/React.forwardRef(function StormTracker24(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref120, children);
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
});

var StormTracker20 = /*#__PURE__*/React.forwardRef(function StormTracker20(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref122, children);
});

var _ref124 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
});

var StormTracker16 = /*#__PURE__*/React.forwardRef(function StormTracker16(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref124, children);
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
});

var _ref127 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
});

var Strawberry32 = /*#__PURE__*/React.forwardRef(function Strawberry32(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref126, _ref127, children);
});

var _ref129 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
});

var _ref130 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
});

var Strawberry24 = /*#__PURE__*/React.forwardRef(function Strawberry24(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref129, _ref130, children);
});

var _ref132 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
});

var _ref133 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
});

var Strawberry20 = /*#__PURE__*/React.forwardRef(function Strawberry20(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref132, _ref133, children);
});

var _ref135 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
});

var _ref136 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
});

var Strawberry16 = /*#__PURE__*/React.forwardRef(function Strawberry16(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref135, _ref136, children);
});

var _ref138 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
});

var WatsonHealthStressBreathEditor32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor32(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref138, children);
});

var _ref140 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
});

var WatsonHealthStressBreathEditor24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor24(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref140, children);
});

var _ref142 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
});

var WatsonHealthStressBreathEditor20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor20(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref142, children);
});

var _ref144 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
});

var WatsonHealthStressBreathEditor16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor16(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref144, children);
});

var _ref146 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
});

var StringInteger32 = /*#__PURE__*/React.forwardRef(function StringInteger32(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref146, children);
});

var _ref148 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
});

var StringInteger24 = /*#__PURE__*/React.forwardRef(function StringInteger24(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref148, children);
});

var _ref150 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
});

var StringInteger20 = /*#__PURE__*/React.forwardRef(function StringInteger20(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref150, children);
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
});

var StringInteger16 = /*#__PURE__*/React.forwardRef(function StringInteger16(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref152, children);
});

var _ref154 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
});

var StringText32 = /*#__PURE__*/React.forwardRef(function StringText32(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref154, children);
});

var _ref156 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
});

var StringText24 = /*#__PURE__*/React.forwardRef(function StringText24(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref156, children);
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
});

var StringText20 = /*#__PURE__*/React.forwardRef(function StringText20(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref158, children);
});

var _ref160 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
});

var StringText16 = /*#__PURE__*/React.forwardRef(function StringText16(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref160, children);
});

var _ref162 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyNext32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext32(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref162, children);
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyNext24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext24(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref164, children);
});

var _ref166 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyNext20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext20(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref166, children);
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyNext16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext16(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref168, children);
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyPrevious32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious32(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref170, children);
});

var _ref172 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyPrevious24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious24(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref172, children);
});

var _ref174 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyPrevious20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious20(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref174, children);
});

var _ref176 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
});

var WatsonHealthStudyPrevious16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious16(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref176, children);
});

var _ref178 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
});

var _ref179 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
});

var WatsonHealthStudySkip32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip32(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref178, _ref179, children);
});

var _ref181 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
});

var _ref182 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
});

var WatsonHealthStudySkip24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip24(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref181, _ref182, children);
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
});

var _ref185 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
});

var WatsonHealthStudySkip20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip20(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref184, _ref185, children);
});

var _ref187 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
});

var _ref188 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
});

var WatsonHealthStudySkip16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip16(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref187, _ref188, children);
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
});

var WatsonHealthSubVolume32 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume32(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref190, children);
});

var _ref192 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
});

var WatsonHealthSubVolume24 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume24(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref192, children);
});

var _ref194 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
});

var WatsonHealthSubVolume20 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume20(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref194, children);
});

var _ref196 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
});

var WatsonHealthSubVolume16 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume16(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref196, children);
});

var _ref198 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var Subtract32 = /*#__PURE__*/React.forwardRef(function Subtract32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref198, children);
});

var _ref200 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var Subtract24 = /*#__PURE__*/React.forwardRef(function Subtract24(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref200, children);
});

var _ref202 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var Subtract20 = /*#__PURE__*/React.forwardRef(function Subtract20(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref202, children);
});

var _ref204 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var Subtract16 = /*#__PURE__*/React.forwardRef(function Subtract16(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref204, children);
});

var _ref206 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref207 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt32 = /*#__PURE__*/React.forwardRef(function SubtractAlt32(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref206, _ref207, children);
});

var _ref209 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref210 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt24 = /*#__PURE__*/React.forwardRef(function SubtractAlt24(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref209, _ref210, children);
});

var _ref212 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref213 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt20 = /*#__PURE__*/React.forwardRef(function SubtractAlt20(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref212, _ref213, children);
});

var _ref215 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref216 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt16 = /*#__PURE__*/React.forwardRef(function SubtractAlt16(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref215, _ref216, children);
});

var _ref218 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
});

var SummaryKpi32 = /*#__PURE__*/React.forwardRef(function SummaryKpi32(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref218, children);
});

var _ref220 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
});

var SummaryKpi24 = /*#__PURE__*/React.forwardRef(function SummaryKpi24(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref220, children);
});

var _ref222 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
});

var SummaryKpi20 = /*#__PURE__*/React.forwardRef(function SummaryKpi20(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref222, children);
});

var _ref224 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
});

var SummaryKpi16 = /*#__PURE__*/React.forwardRef(function SummaryKpi16(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref224, children);
});

var _ref226 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref227 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref228 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref229 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref230 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref231 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref232 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref233 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref234 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun32 = /*#__PURE__*/React.forwardRef(function Sun32(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, children);
});

var _ref236 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref237 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref238 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref239 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref240 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref241 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref242 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref243 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref244 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun24 = /*#__PURE__*/React.forwardRef(function Sun24(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, children);
});

var _ref246 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref247 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref248 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref249 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref250 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref251 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref252 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref253 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref254 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun20 = /*#__PURE__*/React.forwardRef(function Sun20(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, children);
});

var _ref256 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref257 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref258 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref259 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref260 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref261 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref262 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref263 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref264 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun16 = /*#__PURE__*/React.forwardRef(function Sun16(_ref255, ref) {
  var children = _ref255.children,
      rest = _objectWithoutProperties(_ref255, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, children);
});

var _ref266 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref267 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref269 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref270 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref271 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref272 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref273 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref274 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny32 = /*#__PURE__*/React.forwardRef(function Sunny32(_ref265, ref) {
  var children = _ref265.children,
      rest = _objectWithoutProperties(_ref265, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny32']) {
      didWarnAboutDeprecation['Sunny32'] = true;
      console.warn("The Sunny32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, children);
});

var _ref276 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref277 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref278 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref279 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref280 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref281 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref282 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref283 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref284 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny24 = /*#__PURE__*/React.forwardRef(function Sunny24(_ref275, ref) {
  var children = _ref275.children,
      rest = _objectWithoutProperties(_ref275, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny24']) {
      didWarnAboutDeprecation['Sunny24'] = true;
      console.warn("The Sunny24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, children);
});

var _ref286 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref287 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref288 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref289 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref290 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref291 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref293 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref294 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny20 = /*#__PURE__*/React.forwardRef(function Sunny20(_ref285, ref) {
  var children = _ref285.children,
      rest = _objectWithoutProperties(_ref285, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny20']) {
      didWarnAboutDeprecation['Sunny20'] = true;
      console.warn("The Sunny20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, children);
});

var _ref296 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref297 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref298 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref299 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref300 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref301 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref302 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref303 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref304 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny16 = /*#__PURE__*/React.forwardRef(function Sunny16(_ref295, ref) {
  var children = _ref295.children,
      rest = _objectWithoutProperties(_ref295, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny16']) {
      didWarnAboutDeprecation['Sunny16'] = true;
      console.warn("The Sunny16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, children);
});

var _ref306 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref307 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref308 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref309 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref310 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise32 = /*#__PURE__*/React.forwardRef(function Sunrise32(_ref305, ref) {
  var children = _ref305.children,
      rest = _objectWithoutProperties(_ref305, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref306, _ref307, _ref308, _ref309, _ref310, children);
});

var _ref312 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref313 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref314 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref315 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref316 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise24 = /*#__PURE__*/React.forwardRef(function Sunrise24(_ref311, ref) {
  var children = _ref311.children,
      rest = _objectWithoutProperties(_ref311, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref312, _ref313, _ref314, _ref315, _ref316, children);
});

var _ref318 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref319 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref320 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref321 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref322 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise20 = /*#__PURE__*/React.forwardRef(function Sunrise20(_ref317, ref) {
  var children = _ref317.children,
      rest = _objectWithoutProperties(_ref317, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref318, _ref319, _ref320, _ref321, _ref322, children);
});

var _ref324 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref325 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref327 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise16 = /*#__PURE__*/React.forwardRef(function Sunrise16(_ref323, ref) {
  var children = _ref323.children,
      rest = _objectWithoutProperties(_ref323, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref324, _ref325, _ref326, _ref327, _ref328, children);
});

var _ref330 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref331 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref332 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref333 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref334 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref335 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref336 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset32 = /*#__PURE__*/React.forwardRef(function Sunset32(_ref329, ref) {
  var children = _ref329.children,
      rest = _objectWithoutProperties(_ref329, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, children);
});

var _ref338 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref339 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref341 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref342 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref343 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref344 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset24 = /*#__PURE__*/React.forwardRef(function Sunset24(_ref337, ref) {
  var children = _ref337.children,
      rest = _objectWithoutProperties(_ref337, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, children);
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref347 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref348 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref349 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref350 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref351 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref352 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset20 = /*#__PURE__*/React.forwardRef(function Sunset20(_ref345, ref) {
  var children = _ref345.children,
      rest = _objectWithoutProperties(_ref345, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, children);
});

var _ref354 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref355 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref356 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref357 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref358 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref359 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref360 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset16 = /*#__PURE__*/React.forwardRef(function Sunset16(_ref353, ref) {
  var children = _ref353.children,
      rest = _objectWithoutProperties(_ref353, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, children);
});

var _ref362 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg32 = /*#__PURE__*/React.forwardRef(function Svg32(_ref361, ref) {
  var children = _ref361.children,
      rest = _objectWithoutProperties(_ref361, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref362, children);
});

var _ref364 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg24 = /*#__PURE__*/React.forwardRef(function Svg24(_ref363, ref) {
  var children = _ref363.children,
      rest = _objectWithoutProperties(_ref363, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref364, children);
});

var _ref366 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg20 = /*#__PURE__*/React.forwardRef(function Svg20(_ref365, ref) {
  var children = _ref365.children,
      rest = _objectWithoutProperties(_ref365, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref366, children);
});

var _ref368 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg16 = /*#__PURE__*/React.forwardRef(function Svg16(_ref367, ref) {
  var children = _ref367.children,
      rest = _objectWithoutProperties(_ref367, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref368, children);
});

var _ref370 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim32 = /*#__PURE__*/React.forwardRef(function Swim32(_ref369, ref) {
  var children = _ref369.children,
      rest = _objectWithoutProperties(_ref369, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref370, children);
});

var _ref372 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim24 = /*#__PURE__*/React.forwardRef(function Swim24(_ref371, ref) {
  var children = _ref371.children,
      rest = _objectWithoutProperties(_ref371, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref372, children);
});

var _ref374 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim20 = /*#__PURE__*/React.forwardRef(function Swim20(_ref373, ref) {
  var children = _ref373.children,
      rest = _objectWithoutProperties(_ref373, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref374, children);
});

var _ref376 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim16 = /*#__PURE__*/React.forwardRef(function Swim16(_ref375, ref) {
  var children = _ref375.children,
      rest = _objectWithoutProperties(_ref375, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref376, children);
});

var _ref378 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher32 = /*#__PURE__*/React.forwardRef(function Switcher32(_ref377, ref) {
  var children = _ref377.children,
      rest = _objectWithoutProperties(_ref377, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref378, children);
});

var _ref380 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher24 = /*#__PURE__*/React.forwardRef(function Switcher24(_ref379, ref) {
  var children = _ref379.children,
      rest = _objectWithoutProperties(_ref379, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref380, children);
});

var _ref382 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher20 = /*#__PURE__*/React.forwardRef(function Switcher20(_ref381, ref) {
  var children = _ref381.children,
      rest = _objectWithoutProperties(_ref381, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref382, children);
});

var _ref384 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher16 = /*#__PURE__*/React.forwardRef(function Switcher16(_ref383, ref) {
  var children = _ref383.children,
      rest = _objectWithoutProperties(_ref383, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref384, children);
});

var _ref386 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref387 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref388 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref389 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision32 = /*#__PURE__*/React.forwardRef(function SysProvision32(_ref385, ref) {
  var children = _ref385.children,
      rest = _objectWithoutProperties(_ref385, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref386, _ref387, _ref388, _ref389, children);
});

var _ref391 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref392 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref393 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref394 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision24 = /*#__PURE__*/React.forwardRef(function SysProvision24(_ref390, ref) {
  var children = _ref390.children,
      rest = _objectWithoutProperties(_ref390, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref391, _ref392, _ref393, _ref394, children);
});

var _ref396 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref397 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref398 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref399 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision20 = /*#__PURE__*/React.forwardRef(function SysProvision20(_ref395, ref) {
  var children = _ref395.children,
      rest = _objectWithoutProperties(_ref395, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref396, _ref397, _ref398, _ref399, children);
});

var _ref401 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref402 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref403 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref404 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision16 = /*#__PURE__*/React.forwardRef(function SysProvision16(_ref400, ref) {
  var children = _ref400.children,
      rest = _objectWithoutProperties(_ref400, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref401, _ref402, _ref403, _ref404, children);
});

var _ref406 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT32 = /*#__PURE__*/React.forwardRef(function QT32(_ref405, ref) {
  var children = _ref405.children,
      rest = _objectWithoutProperties(_ref405, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref406, children);
});

var _ref408 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT24 = /*#__PURE__*/React.forwardRef(function QT24(_ref407, ref) {
  var children = _ref407.children,
      rest = _objectWithoutProperties(_ref407, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref408, children);
});

var _ref410 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT20 = /*#__PURE__*/React.forwardRef(function QT20(_ref409, ref) {
  var children = _ref409.children,
      rest = _objectWithoutProperties(_ref409, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref410, children);
});

var _ref412 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT16 = /*#__PURE__*/React.forwardRef(function QT16(_ref411, ref) {
  var children = _ref411.children,
      rest = _objectWithoutProperties(_ref411, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref412, children);
});

var _ref414 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt32 = /*#__PURE__*/React.forwardRef(function QTAlt32(_ref413, ref) {
  var children = _ref413.children,
      rest = _objectWithoutProperties(_ref413, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref414, children);
});

var _ref416 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt24 = /*#__PURE__*/React.forwardRef(function QTAlt24(_ref415, ref) {
  var children = _ref415.children,
      rest = _objectWithoutProperties(_ref415, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref416, children);
});

var _ref418 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt20 = /*#__PURE__*/React.forwardRef(function QTAlt20(_ref417, ref) {
  var children = _ref417.children,
      rest = _objectWithoutProperties(_ref417, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref418, children);
});

var _ref420 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt16 = /*#__PURE__*/React.forwardRef(function QTAlt16(_ref419, ref) {
  var children = _ref419.children,
      rest = _objectWithoutProperties(_ref419, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref420, children);
});

var _ref422 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table32 = /*#__PURE__*/React.forwardRef(function Table32(_ref421, ref) {
  var children = _ref421.children,
      rest = _objectWithoutProperties(_ref421, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref422, children);
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table24 = /*#__PURE__*/React.forwardRef(function Table24(_ref423, ref) {
  var children = _ref423.children,
      rest = _objectWithoutProperties(_ref423, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref424, children);
});

var _ref426 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table20 = /*#__PURE__*/React.forwardRef(function Table20(_ref425, ref) {
  var children = _ref425.children,
      rest = _objectWithoutProperties(_ref425, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref426, children);
});

var _ref428 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table16 = /*#__PURE__*/React.forwardRef(function Table16(_ref427, ref) {
  var children = _ref427.children,
      rest = _objectWithoutProperties(_ref427, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref428, children);
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit32 = /*#__PURE__*/React.forwardRef(function TableSplit32(_ref429, ref) {
  var children = _ref429.children,
      rest = _objectWithoutProperties(_ref429, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref430, children);
});

var _ref432 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit24 = /*#__PURE__*/React.forwardRef(function TableSplit24(_ref431, ref) {
  var children = _ref431.children,
      rest = _objectWithoutProperties(_ref431, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref432, children);
});

var _ref434 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit20 = /*#__PURE__*/React.forwardRef(function TableSplit20(_ref433, ref) {
  var children = _ref433.children,
      rest = _objectWithoutProperties(_ref433, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref434, children);
});

var _ref436 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit16 = /*#__PURE__*/React.forwardRef(function TableSplit16(_ref435, ref) {
  var children = _ref435.children,
      rest = _objectWithoutProperties(_ref435, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref436, children);
});

var _ref438 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents32 = /*#__PURE__*/React.forwardRef(function TableOfContents32(_ref437, ref) {
  var children = _ref437.children,
      rest = _objectWithoutProperties(_ref437, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref438, children);
});

var _ref440 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents24 = /*#__PURE__*/React.forwardRef(function TableOfContents24(_ref439, ref) {
  var children = _ref439.children,
      rest = _objectWithoutProperties(_ref439, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref440, children);
});

var _ref442 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents20 = /*#__PURE__*/React.forwardRef(function TableOfContents20(_ref441, ref) {
  var children = _ref441.children,
      rest = _objectWithoutProperties(_ref441, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref442, children);
});

var _ref444 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents16 = /*#__PURE__*/React.forwardRef(function TableOfContents16(_ref443, ref) {
  var children = _ref443.children,
      rest = _objectWithoutProperties(_ref443, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref444, children);
});

var _ref446 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref447 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet32 = /*#__PURE__*/React.forwardRef(function Tablet32(_ref445, ref) {
  var children = _ref445.children,
      rest = _objectWithoutProperties(_ref445, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref446, _ref447, children);
});

var _ref449 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref450 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet24 = /*#__PURE__*/React.forwardRef(function Tablet24(_ref448, ref) {
  var children = _ref448.children,
      rest = _objectWithoutProperties(_ref448, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref449, _ref450, children);
});

var _ref452 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref453 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet20 = /*#__PURE__*/React.forwardRef(function Tablet20(_ref451, ref) {
  var children = _ref451.children,
      rest = _objectWithoutProperties(_ref451, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref452, _ref453, children);
});

var _ref455 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref456 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet16 = /*#__PURE__*/React.forwardRef(function Tablet16(_ref454, ref) {
  var children = _ref454.children,
      rest = _objectWithoutProperties(_ref454, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref455, _ref456, children);
});

var _ref458 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref459 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape32 = /*#__PURE__*/React.forwardRef(function TabletLandscape32(_ref457, ref) {
  var children = _ref457.children,
      rest = _objectWithoutProperties(_ref457, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref458, _ref459, children);
});

var _ref461 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref462 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape24 = /*#__PURE__*/React.forwardRef(function TabletLandscape24(_ref460, ref) {
  var children = _ref460.children,
      rest = _objectWithoutProperties(_ref460, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref461, _ref462, children);
});

var _ref464 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref465 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape20 = /*#__PURE__*/React.forwardRef(function TabletLandscape20(_ref463, ref) {
  var children = _ref463.children,
      rest = _objectWithoutProperties(_ref463, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref464, _ref465, children);
});

var _ref467 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref468 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape16 = /*#__PURE__*/React.forwardRef(function TabletLandscape16(_ref466, ref) {
  var children = _ref466.children,
      rest = _objectWithoutProperties(_ref466, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref467, _ref468, children);
});

var _ref470 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref471 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag32 = /*#__PURE__*/React.forwardRef(function Tag32(_ref469, ref) {
  var children = _ref469.children,
      rest = _objectWithoutProperties(_ref469, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref470, _ref471, children);
});

var _ref473 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag24 = /*#__PURE__*/React.forwardRef(function Tag24(_ref472, ref) {
  var children = _ref472.children,
      rest = _objectWithoutProperties(_ref472, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref473, _ref474, children);
});

var _ref476 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref477 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag20 = /*#__PURE__*/React.forwardRef(function Tag20(_ref475, ref) {
  var children = _ref475.children,
      rest = _objectWithoutProperties(_ref475, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref476, _ref477, children);
});

var _ref479 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag16 = /*#__PURE__*/React.forwardRef(function Tag16(_ref478, ref) {
  var children = _ref478.children,
      rest = _objectWithoutProperties(_ref478, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref479, _ref480, children);
});

var _ref482 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref483 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit32 = /*#__PURE__*/React.forwardRef(function TagEdit32(_ref481, ref) {
  var children = _ref481.children,
      rest = _objectWithoutProperties(_ref481, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref482, _ref483, children);
});

var _ref485 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref486 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit24 = /*#__PURE__*/React.forwardRef(function TagEdit24(_ref484, ref) {
  var children = _ref484.children,
      rest = _objectWithoutProperties(_ref484, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref485, _ref486, children);
});

var _ref488 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref489 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit20 = /*#__PURE__*/React.forwardRef(function TagEdit20(_ref487, ref) {
  var children = _ref487.children,
      rest = _objectWithoutProperties(_ref487, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref488, _ref489, children);
});

var _ref491 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit16 = /*#__PURE__*/React.forwardRef(function TagEdit16(_ref490, ref) {
  var children = _ref490.children,
      rest = _objectWithoutProperties(_ref490, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref491, _ref492, children);
});

var _ref494 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref495 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref496 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup32 = /*#__PURE__*/React.forwardRef(function TagGroup32(_ref493, ref) {
  var children = _ref493.children,
      rest = _objectWithoutProperties(_ref493, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref494, _ref495, _ref496, children);
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref499 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref500 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup24 = /*#__PURE__*/React.forwardRef(function TagGroup24(_ref497, ref) {
  var children = _ref497.children,
      rest = _objectWithoutProperties(_ref497, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref498, _ref499, _ref500, children);
});

var _ref502 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref503 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup20 = /*#__PURE__*/React.forwardRef(function TagGroup20(_ref501, ref) {
  var children = _ref501.children,
      rest = _objectWithoutProperties(_ref501, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref502, _ref503, _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref507 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref508 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup16 = /*#__PURE__*/React.forwardRef(function TagGroup16(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, _ref507, _ref508, children);
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref511 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task32 = /*#__PURE__*/React.forwardRef(function Task32(_ref509, ref) {
  var children = _ref509.children,
      rest = _objectWithoutProperties(_ref509, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref510, _ref511, children);
});

var _ref513 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref514 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task24 = /*#__PURE__*/React.forwardRef(function Task24(_ref512, ref) {
  var children = _ref512.children,
      rest = _objectWithoutProperties(_ref512, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref513, _ref514, children);
});

var _ref516 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref517 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task20 = /*#__PURE__*/React.forwardRef(function Task20(_ref515, ref) {
  var children = _ref515.children,
      rest = _objectWithoutProperties(_ref515, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref516, _ref517, children);
});

var _ref519 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref520 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task16 = /*#__PURE__*/React.forwardRef(function Task16(_ref518, ref) {
  var children = _ref518.children,
      rest = _objectWithoutProperties(_ref518, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref519, _ref520, children);
});

var _ref522 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref523 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref524 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref525 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView32 = /*#__PURE__*/React.forwardRef(function TaskView32(_ref521, ref) {
  var children = _ref521.children,
      rest = _objectWithoutProperties(_ref521, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref522, _ref523, _ref524, _ref525, children);
});

var _ref527 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref528 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref529 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref530 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView24 = /*#__PURE__*/React.forwardRef(function TaskView24(_ref526, ref) {
  var children = _ref526.children,
      rest = _objectWithoutProperties(_ref526, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref527, _ref528, _ref529, _ref530, children);
});

var _ref532 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref533 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref534 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref535 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView20 = /*#__PURE__*/React.forwardRef(function TaskView20(_ref531, ref) {
  var children = _ref531.children,
      rest = _objectWithoutProperties(_ref531, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref532, _ref533, _ref534, _ref535, children);
});

var _ref537 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref538 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref539 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref540 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView16 = /*#__PURE__*/React.forwardRef(function TaskView16(_ref536, ref) {
  var children = _ref536.children,
      rest = _objectWithoutProperties(_ref536, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref537, _ref538, _ref539, _ref540, children);
});

var _ref542 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste32 = /*#__PURE__*/React.forwardRef(function Taste32(_ref541, ref) {
  var children = _ref541.children,
      rest = _objectWithoutProperties(_ref541, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref542, children);
});

var _ref544 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste24 = /*#__PURE__*/React.forwardRef(function Taste24(_ref543, ref) {
  var children = _ref543.children,
      rest = _objectWithoutProperties(_ref543, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref544, children);
});

var _ref546 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste20 = /*#__PURE__*/React.forwardRef(function Taste20(_ref545, ref) {
  var children = _ref545.children,
      rest = _objectWithoutProperties(_ref545, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref546, children);
});

var _ref548 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste16 = /*#__PURE__*/React.forwardRef(function Taste16(_ref547, ref) {
  var children = _ref547.children,
      rest = _objectWithoutProperties(_ref547, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref548, children);
});

var _ref550 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi32 = /*#__PURE__*/React.forwardRef(function Taxi32(_ref549, ref) {
  var children = _ref549.children,
      rest = _objectWithoutProperties(_ref549, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref550, children);
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi24 = /*#__PURE__*/React.forwardRef(function Taxi24(_ref551, ref) {
  var children = _ref551.children,
      rest = _objectWithoutProperties(_ref551, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref552, children);
});

var _ref554 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi20 = /*#__PURE__*/React.forwardRef(function Taxi20(_ref553, ref) {
  var children = _ref553.children,
      rest = _objectWithoutProperties(_ref553, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref554, children);
});

var _ref556 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi16 = /*#__PURE__*/React.forwardRef(function Taxi16(_ref555, ref) {
  var children = _ref555.children,
      rest = _objectWithoutProperties(_ref555, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref556, children);
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature32 = /*#__PURE__*/React.forwardRef(function Temperature32(_ref557, ref) {
  var children = _ref557.children,
      rest = _objectWithoutProperties(_ref557, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref558, children);
});

var _ref560 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature24 = /*#__PURE__*/React.forwardRef(function Temperature24(_ref559, ref) {
  var children = _ref559.children,
      rest = _objectWithoutProperties(_ref559, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref560, children);
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature20 = /*#__PURE__*/React.forwardRef(function Temperature20(_ref561, ref) {
  var children = _ref561.children,
      rest = _objectWithoutProperties(_ref561, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref562, children);
});

var _ref564 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature16 = /*#__PURE__*/React.forwardRef(function Temperature16(_ref563, ref) {
  var children = _ref563.children,
      rest = _objectWithoutProperties(_ref563, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref564, children);
});

var _ref566 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
});

var _ref567 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFeelsLike32 = /*#__PURE__*/React.forwardRef(function TemperatureFeelsLike32(_ref565, ref) {
  var children = _ref565.children,
      rest = _objectWithoutProperties(_ref565, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref566, _ref567, children);
});

var _ref569 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
});

var _ref570 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFeelsLike24 = /*#__PURE__*/React.forwardRef(function TemperatureFeelsLike24(_ref568, ref) {
  var children = _ref568.children,
      rest = _objectWithoutProperties(_ref568, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref569, _ref570, children);
});

var _ref572 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
});

var _ref573 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFeelsLike20 = /*#__PURE__*/React.forwardRef(function TemperatureFeelsLike20(_ref571, ref) {
  var children = _ref571.children,
      rest = _objectWithoutProperties(_ref571, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref572, _ref573, children);
});

var _ref575 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
});

var _ref576 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFeelsLike16 = /*#__PURE__*/React.forwardRef(function TemperatureFeelsLike16(_ref574, ref) {
  var children = _ref574.children,
      rest = _objectWithoutProperties(_ref574, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref575, _ref576, children);
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref579 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFrigid32 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid32(_ref577, ref) {
  var children = _ref577.children,
      rest = _objectWithoutProperties(_ref577, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref578, _ref579, children);
});

var _ref581 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref582 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFrigid24 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid24(_ref580, ref) {
  var children = _ref580.children,
      rest = _objectWithoutProperties(_ref580, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref581, _ref582, children);
});

var _ref584 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref585 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFrigid20 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid20(_ref583, ref) {
  var children = _ref583.children,
      rest = _objectWithoutProperties(_ref583, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref584, _ref585, children);
});

var _ref587 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref588 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureFrigid16 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid16(_ref586, ref) {
  var children = _ref586.children,
      rest = _objectWithoutProperties(_ref586, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref587, _ref588, children);
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref591 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref592 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref593 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref594 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureHot32 = /*#__PURE__*/React.forwardRef(function TemperatureHot32(_ref589, ref) {
  var children = _ref589.children,
      rest = _objectWithoutProperties(_ref589, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref590, _ref591, _ref592, _ref593, _ref594, children);
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref597 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref598 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref599 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureHot24 = /*#__PURE__*/React.forwardRef(function TemperatureHot24(_ref595, ref) {
  var children = _ref595.children,
      rest = _objectWithoutProperties(_ref595, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref596, _ref597, _ref598, _ref599, _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref603 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref604 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref605 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref606 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureHot20 = /*#__PURE__*/React.forwardRef(function TemperatureHot20(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, _ref603, _ref604, _ref605, _ref606, children);
});

var _ref608 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref609 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref610 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref611 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref612 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
});

var TemperatureHot16 = /*#__PURE__*/React.forwardRef(function TemperatureHot16(_ref607, ref) {
  var children = _ref607.children,
      rest = _objectWithoutProperties(_ref607, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref608, _ref609, _ref610, _ref611, _ref612, children);
});

var _ref614 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
});

var TemperatureInversion32 = /*#__PURE__*/React.forwardRef(function TemperatureInversion32(_ref613, ref) {
  var children = _ref613.children,
      rest = _objectWithoutProperties(_ref613, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref614, children);
});

var _ref616 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
});

var TemperatureInversion24 = /*#__PURE__*/React.forwardRef(function TemperatureInversion24(_ref615, ref) {
  var children = _ref615.children,
      rest = _objectWithoutProperties(_ref615, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref616, children);
});

var _ref618 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
});

var TemperatureInversion20 = /*#__PURE__*/React.forwardRef(function TemperatureInversion20(_ref617, ref) {
  var children = _ref617.children,
      rest = _objectWithoutProperties(_ref617, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref618, children);
});

var _ref620 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
});

var TemperatureInversion16 = /*#__PURE__*/React.forwardRef(function TemperatureInversion16(_ref619, ref) {
  var children = _ref619.children,
      rest = _objectWithoutProperties(_ref619, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref620, children);
});

var _ref622 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref623 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMax32 = /*#__PURE__*/React.forwardRef(function TemperatureMax32(_ref621, ref) {
  var children = _ref621.children,
      rest = _objectWithoutProperties(_ref621, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref622, _ref623, children);
});

var _ref625 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref626 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMax24 = /*#__PURE__*/React.forwardRef(function TemperatureMax24(_ref624, ref) {
  var children = _ref624.children,
      rest = _objectWithoutProperties(_ref624, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref625, _ref626, children);
});

var _ref628 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref629 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMax20 = /*#__PURE__*/React.forwardRef(function TemperatureMax20(_ref627, ref) {
  var children = _ref627.children,
      rest = _objectWithoutProperties(_ref627, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref628, _ref629, children);
});

var _ref631 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref632 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMax16 = /*#__PURE__*/React.forwardRef(function TemperatureMax16(_ref630, ref) {
  var children = _ref630.children,
      rest = _objectWithoutProperties(_ref630, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref631, _ref632, children);
});

var _ref634 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
});

var _ref635 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMin32 = /*#__PURE__*/React.forwardRef(function TemperatureMin32(_ref633, ref) {
  var children = _ref633.children,
      rest = _objectWithoutProperties(_ref633, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref634, _ref635, children);
});

var _ref637 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
});

var _ref638 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMin24 = /*#__PURE__*/React.forwardRef(function TemperatureMin24(_ref636, ref) {
  var children = _ref636.children,
      rest = _objectWithoutProperties(_ref636, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref637, _ref638, children);
});

var _ref640 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
});

var _ref641 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMin20 = /*#__PURE__*/React.forwardRef(function TemperatureMin20(_ref639, ref) {
  var children = _ref639.children,
      rest = _objectWithoutProperties(_ref639, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref640, _ref641, children);
});

var _ref643 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
});

var _ref644 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
});

var TemperatureMin16 = /*#__PURE__*/React.forwardRef(function TemperatureMin16(_ref642, ref) {
  var children = _ref642.children,
      rest = _objectWithoutProperties(_ref642, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref643, _ref644, children);
});

var _ref646 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureWater32 = /*#__PURE__*/React.forwardRef(function TemperatureWater32(_ref645, ref) {
  var children = _ref645.children,
      rest = _objectWithoutProperties(_ref645, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref646, children);
});

var _ref648 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureWater24 = /*#__PURE__*/React.forwardRef(function TemperatureWater24(_ref647, ref) {
  var children = _ref647.children,
      rest = _objectWithoutProperties(_ref647, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref648, children);
});

var _ref650 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureWater20 = /*#__PURE__*/React.forwardRef(function TemperatureWater20(_ref649, ref) {
  var children = _ref649.children,
      rest = _objectWithoutProperties(_ref649, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref650, children);
});

var _ref652 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureWater16 = /*#__PURE__*/React.forwardRef(function TemperatureWater16(_ref651, ref) {
  var children = _ref651.children,
      rest = _objectWithoutProperties(_ref651, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref652, children);
});

var _ref654 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template32 = /*#__PURE__*/React.forwardRef(function Template32(_ref653, ref) {
  var children = _ref653.children,
      rest = _objectWithoutProperties(_ref653, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref654, children);
});

var _ref656 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template24 = /*#__PURE__*/React.forwardRef(function Template24(_ref655, ref) {
  var children = _ref655.children,
      rest = _objectWithoutProperties(_ref655, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref656, children);
});

var _ref658 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template20 = /*#__PURE__*/React.forwardRef(function Template20(_ref657, ref) {
  var children = _ref657.children,
      rest = _objectWithoutProperties(_ref657, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref658, children);
});

var _ref660 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template16 = /*#__PURE__*/React.forwardRef(function Template16(_ref659, ref) {
  var children = _ref659.children,
      rest = _objectWithoutProperties(_ref659, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref660, children);
});

var _ref662 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref663 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref664 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis32 = /*#__PURE__*/React.forwardRef(function Tennis32(_ref661, ref) {
  var children = _ref661.children,
      rest = _objectWithoutProperties(_ref661, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref662, _ref663, _ref664, children);
});

var _ref666 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref667 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref668 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis24 = /*#__PURE__*/React.forwardRef(function Tennis24(_ref665, ref) {
  var children = _ref665.children,
      rest = _objectWithoutProperties(_ref665, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref666, _ref667, _ref668, children);
});

var _ref670 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref671 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref672 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis20 = /*#__PURE__*/React.forwardRef(function Tennis20(_ref669, ref) {
  var children = _ref669.children,
      rest = _objectWithoutProperties(_ref669, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref670, _ref671, _ref672, children);
});

var _ref674 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref675 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref676 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis16 = /*#__PURE__*/React.forwardRef(function Tennis16(_ref673, ref) {
  var children = _ref673.children,
      rest = _objectWithoutProperties(_ref673, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref674, _ref675, _ref676, children);
});

var _ref678 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall32 = /*#__PURE__*/React.forwardRef(function TennisBall32(_ref677, ref) {
  var children = _ref677.children,
      rest = _objectWithoutProperties(_ref677, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref678, children);
});

var _ref680 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall24 = /*#__PURE__*/React.forwardRef(function TennisBall24(_ref679, ref) {
  var children = _ref679.children,
      rest = _objectWithoutProperties(_ref679, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref680, children);
});

var _ref682 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall20 = /*#__PURE__*/React.forwardRef(function TennisBall20(_ref681, ref) {
  var children = _ref681.children,
      rest = _objectWithoutProperties(_ref681, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref682, children);
});

var _ref684 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall16 = /*#__PURE__*/React.forwardRef(function TennisBall16(_ref683, ref) {
  var children = _ref683.children,
      rest = _objectWithoutProperties(_ref683, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref684, children);
});

var _ref686 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref687 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref688 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref689 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref690 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term32 = /*#__PURE__*/React.forwardRef(function Term32(_ref685, ref) {
  var children = _ref685.children,
      rest = _objectWithoutProperties(_ref685, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref686, _ref687, _ref688, _ref689, _ref690, children);
});

var _ref692 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref693 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref694 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref695 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref696 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term24 = /*#__PURE__*/React.forwardRef(function Term24(_ref691, ref) {
  var children = _ref691.children,
      rest = _objectWithoutProperties(_ref691, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref692, _ref693, _ref694, _ref695, _ref696, children);
});

var _ref698 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref699 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref700 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref701 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref702 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term20 = /*#__PURE__*/React.forwardRef(function Term20(_ref697, ref) {
  var children = _ref697.children,
      rest = _objectWithoutProperties(_ref697, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref698, _ref699, _ref700, _ref701, _ref702, children);
});

var _ref704 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref705 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref706 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref707 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref708 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term16 = /*#__PURE__*/React.forwardRef(function Term16(_ref703, ref) {
  var children = _ref703.children,
      rest = _objectWithoutProperties(_ref703, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref704, _ref705, _ref706, _ref707, _ref708, children);
});

var _ref710 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref711 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal32 = /*#__PURE__*/React.forwardRef(function Terminal32(_ref709, ref) {
  var children = _ref709.children,
      rest = _objectWithoutProperties(_ref709, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref710, _ref711, children);
});

var _ref713 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref714 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal24 = /*#__PURE__*/React.forwardRef(function Terminal24(_ref712, ref) {
  var children = _ref712.children,
      rest = _objectWithoutProperties(_ref712, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref713, _ref714, children);
});

var _ref716 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref717 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal20 = /*#__PURE__*/React.forwardRef(function Terminal20(_ref715, ref) {
  var children = _ref715.children,
      rest = _objectWithoutProperties(_ref715, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref716, _ref717, children);
});

var _ref719 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref720 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal16 = /*#__PURE__*/React.forwardRef(function Terminal16(_ref718, ref) {
  var children = _ref718.children,
      rest = _objectWithoutProperties(_ref718, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref719, _ref720, children);
});

var _ref722 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter32 = /*#__PURE__*/React.forwardRef(function TextAlignCenter32(_ref721, ref) {
  var children = _ref721.children,
      rest = _objectWithoutProperties(_ref721, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref722, children);
});

var _ref724 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter24 = /*#__PURE__*/React.forwardRef(function TextAlignCenter24(_ref723, ref) {
  var children = _ref723.children,
      rest = _objectWithoutProperties(_ref723, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref724, children);
});

var _ref726 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter20 = /*#__PURE__*/React.forwardRef(function TextAlignCenter20(_ref725, ref) {
  var children = _ref725.children,
      rest = _objectWithoutProperties(_ref725, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref726, children);
});

var _ref728 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter16 = /*#__PURE__*/React.forwardRef(function TextAlignCenter16(_ref727, ref) {
  var children = _ref727.children,
      rest = _objectWithoutProperties(_ref727, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref728, children);
});

var _ref730 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify32 = /*#__PURE__*/React.forwardRef(function TextAlignJustify32(_ref729, ref) {
  var children = _ref729.children,
      rest = _objectWithoutProperties(_ref729, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref730, children);
});

var _ref732 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify24 = /*#__PURE__*/React.forwardRef(function TextAlignJustify24(_ref731, ref) {
  var children = _ref731.children,
      rest = _objectWithoutProperties(_ref731, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref732, children);
});

var _ref734 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify20 = /*#__PURE__*/React.forwardRef(function TextAlignJustify20(_ref733, ref) {
  var children = _ref733.children,
      rest = _objectWithoutProperties(_ref733, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref734, children);
});

var _ref736 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify16 = /*#__PURE__*/React.forwardRef(function TextAlignJustify16(_ref735, ref) {
  var children = _ref735.children,
      rest = _objectWithoutProperties(_ref735, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref736, children);
});

var _ref738 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft32 = /*#__PURE__*/React.forwardRef(function TextAlignLeft32(_ref737, ref) {
  var children = _ref737.children,
      rest = _objectWithoutProperties(_ref737, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref738, children);
});

var _ref740 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft24 = /*#__PURE__*/React.forwardRef(function TextAlignLeft24(_ref739, ref) {
  var children = _ref739.children,
      rest = _objectWithoutProperties(_ref739, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref740, children);
});

var _ref742 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft20 = /*#__PURE__*/React.forwardRef(function TextAlignLeft20(_ref741, ref) {
  var children = _ref741.children,
      rest = _objectWithoutProperties(_ref741, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref742, children);
});

var _ref744 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft16 = /*#__PURE__*/React.forwardRef(function TextAlignLeft16(_ref743, ref) {
  var children = _ref743.children,
      rest = _objectWithoutProperties(_ref743, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref744, children);
});

var _ref746 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight32 = /*#__PURE__*/React.forwardRef(function TextAlignRight32(_ref745, ref) {
  var children = _ref745.children,
      rest = _objectWithoutProperties(_ref745, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref746, children);
});

var _ref748 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight24 = /*#__PURE__*/React.forwardRef(function TextAlignRight24(_ref747, ref) {
  var children = _ref747.children,
      rest = _objectWithoutProperties(_ref747, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref748, children);
});

var _ref750 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight20 = /*#__PURE__*/React.forwardRef(function TextAlignRight20(_ref749, ref) {
  var children = _ref749.children,
      rest = _objectWithoutProperties(_ref749, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref750, children);
});

var _ref752 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight16 = /*#__PURE__*/React.forwardRef(function TextAlignRight16(_ref751, ref) {
  var children = _ref751.children,
      rest = _objectWithoutProperties(_ref751, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref752, children);
});
export { QT16, QT20, QT24, QT32, QTAlt16, QTAlt20, QTAlt24, QTAlt32, StarHalf16, StarHalf20, StarReview16, StarReview20, StarReview24, StarReview32, StayInside16, StayInside20, StayInside24, StayInside32, StemLeafPlot16, StemLeafPlot20, StemLeafPlot24, StemLeafPlot32, Stethoscope16, Stethoscope20, Stethoscope24, Stethoscope32, Stop16, Stop20, Stop24, Stop32, StopFilled16, StopFilled20, StopFilled24, StopFilled32, StopFilledAlt16, StopFilledAlt20, StopFilledAlt24, StopFilledAlt32, StopOutline16, StopOutline20, StopOutline24, StopOutline32, StopOutlineFilled16, StopOutlineFilled20, StopOutlineFilled24, StopOutlineFilled32, StorageRequest16, StorageRequest20, StorageRequest24, StorageRequest32, Store16, Store20, Store24, Store32, StormTracker16, StormTracker20, StormTracker24, StormTracker32, Strawberry16, Strawberry20, Strawberry24, Strawberry32, StringInteger16, StringInteger20, StringInteger24, StringInteger32, StringText16, StringText20, StringText24, StringText32, Subtract16, Subtract20, Subtract24, Subtract32, SubtractAlt16, SubtractAlt20, SubtractAlt24, SubtractAlt32, SummaryKpi16, SummaryKpi20, SummaryKpi24, SummaryKpi32, Sun16, Sun20, Sun24, Sun32, Sunny16, Sunny20, Sunny24, Sunny32, Sunrise16, Sunrise20, Sunrise24, Sunrise32, Sunset16, Sunset20, Sunset24, Sunset32, Svg16, Svg20, Svg24, Svg32, Swim16, Swim20, Swim24, Swim32, Switcher16, Switcher20, Switcher24, Switcher32, SysProvision16, SysProvision20, SysProvision24, SysProvision32, Table16, Table20, Table24, Table32, TableOfContents16, TableOfContents20, TableOfContents24, TableOfContents32, TableSplit16, TableSplit20, TableSplit24, TableSplit32, Tablet16, Tablet20, Tablet24, Tablet32, TabletLandscape16, TabletLandscape20, TabletLandscape24, TabletLandscape32, Tag16, Tag20, Tag24, Tag32, TagEdit16, TagEdit20, TagEdit24, TagEdit32, TagGroup16, TagGroup20, TagGroup24, TagGroup32, Task16, Task20, Task24, Task32, TaskView16, TaskView20, TaskView24, TaskView32, Taste16, Taste20, Taste24, Taste32, Taxi16, Taxi20, Taxi24, Taxi32, Temperature16, Temperature20, Temperature24, Temperature32, TemperatureFeelsLike16, TemperatureFeelsLike20, TemperatureFeelsLike24, TemperatureFeelsLike32, TemperatureFrigid16, TemperatureFrigid20, TemperatureFrigid24, TemperatureFrigid32, TemperatureHot16, TemperatureHot20, TemperatureHot24, TemperatureHot32, TemperatureInversion16, TemperatureInversion20, TemperatureInversion24, TemperatureInversion32, TemperatureMax16, TemperatureMax20, TemperatureMax24, TemperatureMax32, TemperatureMin16, TemperatureMin20, TemperatureMin24, TemperatureMin32, TemperatureWater16, TemperatureWater20, TemperatureWater24, TemperatureWater32, Template16, Template20, Template24, Template32, Tennis16, Tennis20, Tennis24, Tennis32, TennisBall16, TennisBall20, TennisBall24, TennisBall32, Term16, Term20, Term24, Term32, Terminal16, Terminal20, Terminal24, Terminal32, TextAlignCenter16, TextAlignCenter20, TextAlignCenter24, TextAlignCenter32, TextAlignJustify16, TextAlignJustify20, TextAlignJustify24, TextAlignJustify32, TextAlignLeft16, TextAlignLeft20, TextAlignLeft24, TextAlignLeft32, TextAlignRight16, TextAlignRight20, TextAlignRight24, TextAlignRight32, WatsonHealthStressBreathEditor16, WatsonHealthStressBreathEditor20, WatsonHealthStressBreathEditor24, WatsonHealthStressBreathEditor32, WatsonHealthStudyNext16, WatsonHealthStudyNext20, WatsonHealthStudyNext24, WatsonHealthStudyNext32, WatsonHealthStudyPrevious16, WatsonHealthStudyPrevious20, WatsonHealthStudyPrevious24, WatsonHealthStudyPrevious32, WatsonHealthStudySkip16, WatsonHealthStudySkip20, WatsonHealthStudySkip24, WatsonHealthStudySkip32, WatsonHealthSubVolume16, WatsonHealthSubVolume20, WatsonHealthSubVolume24, WatsonHealthSubVolume32 };